<template>
    <div>
        <div class="second-header-wrap">
            <el-button type="primary" size="medium" @click="jumpToPage('resourceManagement/subjectAdd')">添加课程</el-button>

            <el-select size="medium" @change="findMoralEduOLCourseListFunc" v-model="searchPostCode" placeholder="请选择">
                <el-option
                    v-for="(postcodeItem, index) in postcodeList"
                    :key="postcodeItem.areaCode"
                    :label="postcodeItem.areaName"
                    :value="postcodeItem.areaCode">
                </el-option>
            </el-select>

            <el-radio-group @change="findMoralEduOLCourseListFunc" v-model="schoolType" size="medium">
                <el-radio-button :key="0" :label="0">全部</el-radio-button>
                <el-radio-button v-for="(periodItem, index) in schoolPeriodList" :key="index + 1" :label="periodItem.code">
                    {{periodItem.value}}
                </el-radio-button>
            </el-radio-group>


        </div>
        <div class="main-content-wrap custom—scrollbar" :style="{height: mainContainerHeight}">
            <div v-if="subjectList && subjectList.length !== 0" class="inner-content-wrap">
                <div class="main-container">
                    <ul>
                        <li v-for="(subjectItem, index) in subjectList" :key="index"
                            @click="jumpToPage('resourceManagement/resourceList', {courseId: subjectItem.id})" class="course-card-item"
                        >
                            <div class="resource-count">{{subjectItem.resourceCount}}</div>
                            <div class="inner-card-wrap">
                                <div class="item-img-wrap">
                                    <div class="item-cover"
                                         :style="{backgroundImage: `url(${subjectItem.imageJson})`}">
                                    </div>
                                </div>
                                <div class="card-msg-wrap">
                                    <div class="course-title clearfix">
                                        <el-tooltip class="item" effect="dark" :content="subjectItem.courseName" placement="bottom">
                                            <div class="course-name">{{subjectItem.courseName}}</div>
                                        </el-tooltip>
                                        <div class="learning-term">{{parsePeriod(subjectItem.courseLevelCode)}}</div>
                                        <i class="el-icon-edit" style="color: #409EFF;" @click.stop="jumpToPage('resourceManagement/subjectEdit', {id: subjectItem.id})"></i>
                                        <i class="el-icon-delete" style="color: #F56C6C;" @click.stop="deleteSubject(subjectItem.id, index)"></i>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <default-page v-else></default-page>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { findDicsByCode } from '@/api/common/common';
    import {deleteMoralEduOLCourse, findMoralEduOLCourseList, getMoralEduOLResourcePageList, getUserManageAreaCodeList} from '@/api/resourceManagement/resourceManagement';
    import baseMixin from '@/mixins/baseMixin.js';
    import DefaultPage from '@/components/DefaultPage';

    export default {
        name: "subjectList",
        data() {
            return {
                mainContainerHeight: 0,
                subjectList: [],
                schoolPeriodList: [],
                schoolType: 0,
                postcodeList: [],
                searchPostCode: null
            }
        },
        filters: {
            parseTimeStamp(timestamp) {
                return moment(timestamp).format('YYYY-MM-DD');
            },

        },
        components: {
            DefaultPage
        },
        mixins: [baseMixin],
        created() {
            this.pagination.pageSize = 8 ;
            Promise.all([
                getUserManageAreaCodeList()
                    .then(res => res.data)
                    .then(data => {
                        this.postcodeList = data.data;
                        this.searchPostCode = data.data[0].areaCode;
                    }),

                findDicsByCode({
                    dicCode: 'schoolPeriodType'
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.data.length > 0) {
                            this.schoolPeriodList = data.data.filter(item => item.code !== '0');
                            // this.schoolType = data.data[0].code;
                        }
                    })
            ])
                .then(() => {
                    this.findMoralEduOLCourseListFunc();
                });
        },
        mounted() {
            this.mainContainerHeight = `${window.innerHeight - 162}px`;
        },
        methods: {
            findMoralEduOLCourseListFunc() {
                findMoralEduOLCourseList({
                    areaCode: this.searchPostCode,
                    schoolType: this.schoolType === 0 ? '' : this.schoolType
                })
                    .then(res => res.data)
                    .then(data => {
                        this.subjectList = data.data;
                    })
            },
            parsePeriod(period) {
                const periodItem = this.schoolPeriodList.find(({code}) => {
                    return code === period
                });
                return periodItem ? periodItem.value : (period === '0' ? '全段' : period);
            },
            deleteSubject(id, index) {
                this.$confirm('是否确定要删除该课程', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    getMoralEduOLResourcePageList({
                        courseId: id,
                        pageNo: this.pagination.pageNo,
                        pageSize: this.pagination.pageSize,
                        searchTitle: '',
                        searchType: 0
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.data.pagination.total !== 0) {
                                this.$message({
                                    message: '该课程仍包含资源，请先清空',
                                    type: 'error'
                                });
                            } else {
                                deleteMoralEduOLCourse({
                                    id
                                })
                                    .then(res => res.data)
                                    .then(data => {

                                        if(data.result) {
                                            this.$message({
                                                message: '删除成功',
                                                type: 'success'
                                            });
                                            this.subjectList.splice(index, 1);
                                        } else {
                                            this.$message({
                                                message: '删除失败',
                                                type: 'error'
                                            });
                                        }
                                    });
                            }
                        })


                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../commonsPC/styles/platform-global";
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }

    .main-content-wrap {
        width: 100%;
        margin-top: 162px;
        background: url(../../assets/images/common/content-bg.jpg) center center / 100% 100% no-repeat;
        .inner-content-wrap {

            width: 100%;
            overflow: hidden;
            .main-container {
                width: 1320px;
                padding: 30px 10px;
                margin: 0 auto;
                min-height: 560px;
                ul {
                    margin-left: -20px;
                    .course-card-item {
                        float: left;
                        width: 315px;
                        height: 218px;
                        position: relative;
                        -webkit-transition: .3s all linear;
                        transition: .3s all linear;
                        margin-left: 20px;
                        margin-bottom: 50px;
                        background: #fff;
                        box-shadow: 1px 1px 1px 1px #ddd;
                        -webkit-box-shadow: 1px 1px 1px 1px #ddd;
                        .resource-count {
                            position: absolute;
                            font-size: 30px;
                            color: #fff;
                            right: 10px;
                            top: 5px;
                            z-index: 2000;
                        }
                        .inner-card-wrap {
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-decoration: none;
                            color: initial;
                            cursor: pointer;
                            .item-img-wrap {
                                width: 100%;
                                height: 175px;
                                overflow: hidden;
                                position: relative;
                                .item-cover {
                                    @include full;
                                    @include cover-bg;
                                    transition: all 0.6s;
                                }
                                .mask-item {
                                    width: 100%;
                                    height: 100%;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    background-color: rgba(0, 0, 0, 0.3);
                                    opacity: 0;
                                    filter: alpha(opacity=0);
                                    transition: all 0.3s;
                                    button {
                                        position: absolute;
                                        top: 70px;
                                        left: 90px;
                                        transition: ease-in 0.2s;
                                        &:nth-child(2) {
                                            left: 175px;
                                        }
                                        &:hover {
                                            top: 66px;
                                        }
                                    }
                                }
                            }
                            .card-msg-wrap {
                                width: 96%;
                                height: 80px;
                                padding: 0 5px;
                                overflow: hidden;
                                .course-title {
                                    height: 30px;
                                    line-height: 30px;
                                    margin-top: 6px;
                                    font-size: 17px;
                                    .course-name {
                                        float: left;
                                        width: 214px;
                                        @include nowrap;
                                        text-overflow: ellipsis;
                                        @include general-title;
                                    }
                                    .learning-term {
                                        float: left;
                                        margin-left: 8px;
                                        font-size: 15px;
                                        width: 36px;
                                    }
                                    .section-no {
                                        float: left;
                                        margin-left: 8px;
                                        font-size: 15px;
                                        width: 94px;
                                    }
                                }
                            }
                        }
                        &:hover {
                            .mask-item {
                                opacity: 1 !important;
                            }
                            .item-cover {
                                transform: scale(1.15);
                            }
                        }
                    }
                }
            }
        }
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }
    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }
    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }
    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/subjectList.vue